// src/components/admin/UserStatusBadge.tsx
// ============================================================
// SALT — User Status Badge
// Color-coded pill for user status (active/suspended/banned/deleted)
// ============================================================

import React from 'react';

interface UserStatusBadgeProps {
  status: string;
}

const STATUS_CONFIG: Record<string, { className: string; label: string }> = {
  active:    { className: 'sl-user-badge--active',    label: 'Active' },
  suspended: { className: 'sl-user-badge--suspended', label: 'Suspended' },
  banned:    { className: 'sl-user-badge--banned',    label: 'Banned' },
  deleted:   { className: 'sl-user-badge--deleted',   label: 'Deleted' },
};

export default function UserStatusBadge({ status }: UserStatusBadgeProps) {
  const config = STATUS_CONFIG[status] || { className: '', label: status };

  return (
    <span className={`sl-user-badge ${config.className}`}>
      {config.label}
    </span>
  );
}
